module.exports = __webpack_public_path__ + "static/media/sg.67651fbf.svg";